import { type FC, useState } from "react";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import { Button } from "@mui/material";

import { logout } from "../../../authentication/store/auth.slice";
import { useAppDispatch } from "../../../store";

export const SignOutButton: FC = () => {
  const dispatch = useAppDispatch();
  const [isSigningOut, setSigningOut] = useState(false);

  const handleClick = () => {
    setSigningOut(true);
    dispatch(logout());
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<LogoutOutlined />}
      disabled={isSigningOut}
      onClick={handleClick}
    >
      Выйти
    </Button>
  );
};
